module.exports = __webpack_public_path__ + "static/media/codeIcon.6a91c982.svg";